export default {
    excess: 'Omavastuu',
    security: 'Vakuusmaksu',
    fuel_policy: 'Polttoainekäytäntö',
    like_for_like: 'Sama samanlaisella',
    full_to_full: 'Täysi tankki - täysi tankki',
    mileage: 'Kilometrimäärä: {mileage} kilometriä per vuokraus',
    unlimited_mileage: 'Rajoittamaton kilometrimäärä',
    non_refundable: 'Ei palautettavissa',
    free_cancellation_until: 'Ilmainen peruutus asti {date}',
    cancellation_with_terms: 'Peruutus {0} ehtojen mukaisesti',
    t_c_text: 'Ehdot',
    two_free_extras: 'Kaksi ilmaista lisävarustetta noudettaessa',
    glass_tyres_covered: 'Lasit ja renkaat sisältyvät',
    spec_fuel_petrol: 'bensiini',
    spec_fuel_petrol_diesel: 'bensiini/diesel',
};
